import GraphicStandTableHelper from './graphic-stand-table-helper';
import GraphicStandChoiseTableHelper from './graphic-stand-choise-table-helper';
import GraphicWarehouseTableHelper from './graphic-warehouse-table-helper';
import GraphicStandFilterHelper from './graphic-stand-filter-helper';

const GraphicStandHelpers = {
    TableMain: GraphicStandTableHelper,
    TableChoise: GraphicStandChoiseTableHelper,
    TableWarehouse: GraphicWarehouseTableHelper,
    Filter: GraphicStandFilterHelper,
};

export default GraphicStandHelpers;